export default __webpack_public_path__ + "static/media/Buick.0ade6907.svg";